import { Spinner } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './Preloader.css';

export const Preloader = () => {
  return (
    <div className={styles['overlay']}>
      <div className={styles['spinner']}>
        <Spinner size={50} />
      </div>
    </div>
  );
};
